import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import './Config'

import App from './containers/App'

import store from './stores'

import {} from './actions'

import './index.css'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App/>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)